export function interactiveMapSlider() {
    let sliderMap = $(".interactive-map-slider");
    $(window).on("load resize", function () {
        sliderMapInit();
    });

    function sliderMapInit() {
        if (window.innerWidth >= 1200 && sliderMap.hasClass("slick-initialized")) {
            // sliderMap.slick('unslick');
        }
        if (window.innerWidth < 1200 && !sliderMap.hasClass("slick-initialized")) {
            sliderMap.find(".item").removeClass("show");
            sliderMap.parent().find(".hide, .show").removeClass("hide show");
            setTimeout(function () {
                sliderMapOption();
            }, 300);
        }
    }

    function sliderMapOption() {
        sliderMap.not('.slick-initialized').slick({
            slidesToScroll: 1,
            slidesToShow: 1,
            infinite: false,
            arrows: false,
            mobileFirst: true,
            dots: true,
            responsive: [
                {
                    breakpoint: 319,
                    settings: {
                        slidesToShow: 1.13,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2.13
                    }
                },
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 3.13
                    }
                },
                {
                    breakpoint: 1199,
                    settings: "unslick"
                }
            ]
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/interactiveMapSlider.js